import { InteractionType } from '@azure/msal-browser';
import { buildConfig } from './env-config';

export const environment = buildConfig({
  isProduction: false,
  isLocalDev: false,
  apiUrl: 'https://changeover-dev.unilever.com/coapi',
  tenantId: 'f66fae02-5d36-495b-bfe0-78a6ff9f8e6e',
  frontendApplicationId: '4d7cfcc2-6ead-48ce-a1d7-f6ea0613ca57',
  backendApplicationId: '4421bea6-f016-42fd-9e12-635f496a67d5',
  interactionType: InteractionType.Redirect,
});
